"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
Object.defineProperty(exports, "__esModule", { value: true });
exports.env = void 0;
const env_impl_js_1 = require("./env-impl.js");
/**
 * Represent a set of flags as a global singleton.
 */
exports.env = env_impl_js_1.env;
//# sourceMappingURL=env.js.map